/*SYSTEM IMPORTS*/
import React from 'react'
import moment from 'moment'

import './style'
import './media'

import Img from "components/Img";

/*Ui*/
import Cont from 'components/ui/Cont'
import ReviewSlider from 'components/ui/ReviewSlider'
import Review from 'components/ui/Review'
// import ScrollControl from 'components/ui/ScrollControl'

import {Helpers} from "api";
import {DATE_FORMAT} from 'constants/backend'
import Modal from "../../Modal";
import {IsIsset} from "../../../helpers/ValueTests";

/*CORES*/
import AppCore from 'cores/AppCore'

const getData = (data) => {
    if (data) {
        const new_data = moment( data, DATE_FORMAT )

        return new_data.format("DD.MM.YYYY")
    }

    return ""
}

const isTextNeedCut = (text = "") => {
    const width = window.innerWidth

    if (width <= 380 && text.length >= 148) {
        return 148

    } else if (width <= 350 && text.length >= 140) {
        return 140

    } else if (width <= 430 && text.length >= 130) {
        return 130

    } else if (width <= 550 && text.length >= 160) {
        return 160

    } else if (width <= 600 && text.length >= 220) {
        return 220
    } else if(text.length >= 220){
        return 220
    }

    return false
}

const ContReviews = ({
                         id,
                         value:{
                             title = AppCore.Interfaces.t( "DoctorLanding.Ui.ContReviews.Index.Title" ),
                             review = [] }
}) => {

    let main_title = AppCore.Interfaces.t( "DoctorLanding.Ui.ContReviews.Index.Title" )

    if(IsIsset(title)) {
        main_title = title
    }

    return (
        <>
            {review.length > 0 &&
            <Cont id={`block-${id}`} className="cont-reviews">
                <h2>
                    {main_title}
                </h2>

                <ReviewSlider
                    list={review.map(item => (
                        <ReviewItem
                            key={item.id}
                            photo={
                                <Img src={`${Helpers.GetImage(item.avatar[0], "253_251")}`} externals div />
                            }
                            letter={item.name[0]}
                            date={getData(item.date)}
                            name={item.name}
                            needCut={isTextNeedCut(item.quote)}
                            quote={item.quote}
                        />
                    ))}
                />
            </Cont>
            }
        </>
    )
}

class ReviewItem extends React.PureComponent{
    state = {
        openModal: false,
        mouseDown: "",
    }

    getText = (text) => {
        const needCut = isTextNeedCut(text)

        if (
            needCut !== false
        ) {
            return text.substr(0, needCut)
        }

        return text
    }

    handleMouseDown = (e) => {
        this.setState({
            mouseDown: e.clientX
        })
    }

    handleClick = (e) => {
        if (
            e.clientX + 10 >= this.state.mouseDown &&
            e.clientX - 10 <= this.state.mouseDown &&
            this.props.needCut !== false
        ) {
            this.setState({
                openModal: true
            })
        }
    }

    handleCloseModal = () => {
        this.setState({
            openModal: false
        })
    }

    render() {
        const { props, state, getText } = this
        const { openModal } = state

        const modal = (
            <Modal
                isOpen={openModal}
                onRequestClose={this.handleCloseModal}
            >
                <Review
                    photo={props.photo}
                    letter={props.letter}
                    date={props.date}
                    name={props.name}
                    needCut={false}
                >
                    { props.quote }
                </Review>
            </Modal>
        )

        return(
            <>
                <Review
                    photo={props.photo}
                    letter={props.letter}
                    date={props.date}
                    name={props.name}
                    needCut={props.needCut}
                    onOpenModal={this.handleClick}
                    onMouseDown={this.handleMouseDown}
                >
                    { getText(props.quote) }
                </Review>

                {modal}
            </>
        )
    }

}

export default ContReviews